import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FireDepartmentService } from '../../../../services';
import type { FireDepartment } from '../../../../types';
import { SimpleBox } from '../../../atoms';

export function Department(): React.JSX.Element {
  const { firedepartmentId } = useParams();

  const [isLoading, setIsLoading] = React.useState(true);
  const [department, setDepartment] = React.useState<FireDepartment>();

  const loadFireDepartment = async () => {
    if (firedepartmentId) {
      const firefighterResponse = await FireDepartmentService.getFireDepartmentById(firedepartmentId);
      if (firefighterResponse.error) {
        toast.error('Fehler beim Laden der Abteilung 😩');
        console.log(firefighterResponse.message);

        return;
      }
      setDepartment(firefighterResponse.data as FireDepartment);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadFireDepartment().then(() => {});
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <div className={'container mt-10'}>
      <div className='row'>
        <div className='col-8'>
          <SimpleBox>
            <h4>Abteilung</h4>
            <div>Name: {department?.name}</div>
          </SimpleBox>
        </div>
        <div className='col-4'>
          <SimpleBox>
            <h4>Infos</h4>
            <h6>Benutzer: 4</h6>
            <h6>Mitglieder: 20</h6>
            <h6>Kleidungsstücke: 40</h6>
          </SimpleBox>
        </div>
      </div>
      {/* <div className='row mt-4'>
        <div className='col-12'>
          <SimpleBox>
            <h4>Kleidung</h4>
            <table className='table'>
              <thead>
                <tr>
                  <th scope='col'>#</th>
                  <th scope='col'>Typ</th>
                  <th scope='col'>Code</th>
                </tr>
              </thead>
              <tbody>
                {member?.clothes.map((clothe, index) => (
                  <tr key={clothe.id}>
                    <th scope='row'>{index + 1}</th>
                    <td>{getClothingTypeName(clothe.type)}</td>
                    <td>{clothe.code}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </SimpleBox>
        </div>
      </div> */}
    </div>
  );
}
